document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.media-grid__section').forEach((section) => {
    const button = section.querySelector('[data-grid-vid-toggle]');
    if (!button) return;

    const videos = section.querySelectorAll('video');
    
    button.addEventListener('click', () => {
      const allPaused = Array.from(videos).every(video => video.paused);

      videos.forEach(video => { 
        if (allPaused) { 
          video.play(); 
        } else { 
          video.pause(); 
        } 
      }); 
      button.setAttribute('aria-pressed', allPaused ? 'true' : 'false'); 
      button.setAttribute('aria-label', allPaused ? 'Pause video' : 'Play video');
    });
  });
});